export default __webpack_public_path__ + "static/media/Frankishe1.6 ratio.78c9f164.png";